import moment from "moment";
import PropTypes from "prop-types";

import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";

function getCalendarValue({ value, selectionMode }) {
  if (!value) return null;
  if (selectionMode === "multiple") {
    return value?.map((item) => new Date(item)) ?? [];
  }
  return new Date(value);
}

export default function FormCalendar(props) {
  const {
    className,
    isControl = true,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true } = {},
    data: {
      name,
      elValue,
      elChange,
      placeholder = "",
      minDate,
      maxDate,
      view = "date",
      dateFormat = "yy-mm-dd",
      showTime = false,
      showSeconds = false,
      timeOnly = false,
      showIcon = true,
      showButtonBar = true,
      selectionMode = "single",
      disabled = false,
    },
  } = props;

  const onChange = (e, field) => {
    let value = e.value;
    if (selectionMode === "multiple") {
      value = value
        ? value.map((item) => moment(item).format("YYYY-MM-DD"))
        : null;
    } else if (showTime) {
      value = value ? moment(value).format("YYYY-MM-DD HH:mm") : null;
    } else {
      value = value ? moment(value).format("YYYY-MM-DD") : null;
    }

    if (isControl) {
      field.onChange(value);

      if (isSubmitted) {
        trigger();
      } else {
        trigger(name);
      }
    } else {
      elChange({ name, value, options: props.data });
    }
  };

  const renderElement = ({ field, fieldState } = {}) => {
    let value = isControl ? field.value : elValue;
    return (
      <div className={classNames("flex align-items-center", className)}>
        <Calendar
          id={name}
          className={classNames(
            { "p-invalid": isControl && fieldState.invalid },
            "w-full"
          )}
          name={name}
          value={getCalendarValue({ value, selectionMode })}
          onChange={(e) => onChange(e, field)}
          placeholder={placeholder}
          minDate={minDate ? new Date(minDate) : null}
          maxDate={maxDate ? new Date(maxDate) : null}
          view={view}
          dateFormat={dateFormat}
          disabled={!isEdit || disabled}
          showTime={showTime}
          showSeconds={showSeconds}
          timeOnly={timeOnly}
          showIcon={!disabled && showIcon}
          showButtonBar={showButtonBar}
          selectionMode={selectionMode}
          readOnlyInput
        />
      </div>
    );
  };

  return (
    <>
      {isControl ? (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            renderElement({ field, fieldState })
          }
        />
      ) : (
        renderElement()
      )}
    </>
  );
}

FormCalendar.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    dateFormat: PropTypes.string,
    disabled: PropTypes.bool,
    elChange: PropTypes.func,
    elValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
      PropTypes.array,
    ]),
    maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    name: PropTypes.string,
    placeholder: PropTypes.string,
    selectionMode: PropTypes.string,
    showButtonBar: PropTypes.bool,
    showIcon: PropTypes.bool,
    showSeconds: PropTypes.bool,
    showTime: PropTypes.bool,
    timeOnly: PropTypes.bool,
    view: PropTypes.string,
  }).isRequired,
  isControl: PropTypes.bool,
  setting: PropTypes.shape({
    control: PropTypes.object,
    Controller: PropTypes.elementType,
    isEdit: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    trigger: PropTypes.func,
  }),
};
